import React from 'react';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import { isFeatureEnabled } from '../../utils/features';
import { usePostLayoutSize } from '../PostLayoutProvider';
import PostTopicListWithBreadcrumbs from './PostTopicListWithBreadcrumbs';

const POST_FRAGMENT = gql(`
  fragment PublicPostTopicBar_post on PublicPost {
    id
    topics {
      id
      ...PostTopicListWithBreadcrumbs_topic
    }
  }
`);

interface PublicPostTopicBarProps {
  post: DocumentType<typeof POST_FRAGMENT>;
}

const PublicPostTopicBar = ({ post }: PublicPostTopicBarProps) => {
  const postLayoutSize = usePostLayoutSize();

  return (
    <PostTopicListWithBreadcrumbs
      postTopics={post.topics}
      large={
        isFeatureEnabled('new_post_layout')
          ? !['mobile', 'tablet'].includes(postLayoutSize)
          : true
      }
    />
  );
};

export default PublicPostTopicBar;
